import { SSOPlatform } from "components/AuthProvider";
import { NEXT_PUBLIC_APOLLO_247_AUTH_URL } from "helpers/constants";
import fetchSSO from "helpers/fetchSSO";

export const fetchTokenFromAuthService = async (): Promise<any> => {
  let authToken = {};
  try {
    authToken = await fetchSSO(
      `${NEXT_PUBLIC_APOLLO_247_AUTH_URL}/api/fetchAuthToken`,
      "GET",
      {},
      "",
      true,
      "",
      "",
      null,
      "include"
    );
  } catch (err) {
    console.error("Auth service error", err);
  }
  return authToken;
};

export const signInUsingAuthService = async (
  otp: string,
  loginId: string,
  type?: string,
  externalAuthToken?: string,
  ssoPlatform?: string
): Promise<any> => {
  let authToken = {};
  try {
    authToken = await fetchSSO(
      `${NEXT_PUBLIC_APOLLO_247_AUTH_URL}/api/verifyLogin`,
      "POST",
      {
        otp,
        id: loginId,
        loginType: type || "PATIENT",
        externalAuthToken,
        ssoPlatform,
      },
      "",
      true,
      "",
      "",
      null,
      "include",
      true
    );
  } catch (err) {
    console.error("Auth service error", err);
  }
  return authToken;
};

export const fetchNewTokenUsingRefreshToken = async (
  grant_type: string,
  refresh_token: string
): Promise<any> => {
  let resolvedRequest = {};
  try {
    resolvedRequest = await fetchSSO(
      `https://securetoken.googleapis.com/v1/token?key=AIzaSyCu4uyf9ln--tU-8V32nnFyfk8GN4koLI0`,
      "POST",
      { grant_type, refresh_token },
      "",
      true
    );
  } catch (err) {
    console.error("Auth service error", err);
  }
  return resolvedRequest;
};

export const signOutUserUsingAuthService = async (): Promise<any> => {
  let authToken = {};
  try {
    authToken = await fetchSSO(
      `${NEXT_PUBLIC_APOLLO_247_AUTH_URL}/api/logout`,
      "GET",
      {},
      "",
      true,
      "",
      "",
      null,
      "include"
    );
  } catch (err) {
    console.error("Auth service error", err);
  }
};

export const verifyExternalTokenFromAuthService = async (
  externalAuthToken: string,
  ssoPlatform?: string
): Promise<any> => {
  let authToken = {};
  try {
    authToken = await fetchSSO(
      `${NEXT_PUBLIC_APOLLO_247_AUTH_URL}/api/verifyExternalAuthToken`,
      "POST",
      { externalAuthToken, ssoPlatform },
      "",
      true,
      "",
      "",
      null,
      "include",
      true
    );
  } catch (err) {
    console.error("Auth service error", err);
  }
  return authToken;
};
